import React, { useState, useEffect } from "react";
import { Search, ChevronLeft, ChevronRight } from "lucide-react";
import Image_1 from '../../../assets/services-hero/first-image.jpg';
import Image_2 from '../../../assets/services-hero/second-image.jpg';
import Image_3 from '../../../assets/services-hero/third-image.jpg';

const HeroSection = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const heroImages = [Image_1, Image_2, Image_3];

  useEffect(() => {
    const heroInterval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % heroImages.length);
    }, 5000);
    return () => clearInterval(heroInterval);
  }, [heroImages.length]);

  return (
    <section className="bg-gradient-to-r from-[#f0f8ff] to-[#fff8e1] w-full">
      <div className="container mx-auto px-4 py-8 md:py-12 lg:py-16 grid grid-cols-1 md:grid-cols-2 gap-8 items-center">

        {/* Left Section */}
        <div className="space-y-6">
          <h1 className="text-4xl font-bold text-[#0072bc] md:text-5xl lg:text-6xl">
            Home <br /> Maintenance <br />
            <span className="text-[#ffa726]">Made Easy!!</span>
          </h1>
          <p className="text-gray-600 max-w-md">
            Connecting customers and handymens for quick, safe, and affordable bookings.
          </p>
          <div className="relative mt-4 w-full max-w-sm">
            <div className="flex items-center rounded-[10px] border border-[#0072bc] bg-white px-3 py-4">
              <Search className="h-4 w-4 text-gray-400" />
              <input
                type="text"
                placeholder="Search for services..."
                className="w-full border-0 bg-transparent px-2 text-gray-900 text-sm focus:outline-none focus:ring-0"
              />
            </div>
          </div>
        </div>

        {/* Right Section - Image with Rounded Left Side */}
        <div className="relative w-full h-[350px] md:h-[450px] lg:h-[550px] rounded-lg overflow-hidden">
          {heroImages.map((image, index) => (
            <div
              key={index}
              className={`absolute inset-0 transition-opacity duration-1000 ${index === currentSlide ? "opacity-100" : "opacity-0"
                }`}
            >
              <img
                src={image}
                alt={`Slide ${index + 1}`}
                className="w-full h-full object-cover rounded-l-[50%]"
              />
            </div>
          ))}

          {/* Controls */}
          <div className="absolute inset-0 flex items-center justify-between p-4">
            <button
              onClick={() => setCurrentSlide((prev) => (prev - 1 + heroImages.length) % heroImages.length)}
              className="rounded-full bg-black/30 p-2 text-white hover:bg-black/50 transition"
              aria-label="Previous slide"
            >
              <ChevronLeft className="h-6 w-6" />
            </button>
            <button
              onClick={() => setCurrentSlide((prev) => (prev + 1) % heroImages.length)}
              className="rounded-full bg-black/30 p-2 text-white hover:bg-black/50 transition"
              aria-label="Next slide"
            >
              <ChevronRight className="h-6 w-6" />
            </button>
          </div>

          {/* Indicators */}
          <div className="absolute bottom-4 left-0 right-0 flex justify-center space-x-2">
            {heroImages.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentSlide(index)}
                className={`h-2 w-2 rounded-full transition-colors ${index === currentSlide ? "bg-white" : "bg-white/50"
                  }`}
                aria-label={`Go to slide ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
